import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import { BoughtChartCmp } from './components/BoughtChartCmp';
import TariffPrices from './components/TariffPrices';
import RemainingQuantity from './components/RemainingQuantity';
import TransactionsList from './components/TransactionsList';
import CardRow from '../../components/CardRow/CardRow';
import CardRowCard from '../../components/CardRow/CardRowCard';
import PriceDevelopment from '../CustomerDashboard/components/Prices/PriceDevelopment';
import useAppContext from '../../hooks/context/useAppContext';
import { useGetContractProductQuantities } from './hooks/api/contractsApi';

const ContractDetail = ({ contractData }) => {
  const { contractId } = useParams();
  const { getContractProductQuantities, data, error } = useGetContractProductQuantities();
  const [productQuantity, setProductQuantity] = useState();
  const [productQuantityRemaining, setProductQuantityRemaining] = useState();
  const { user } = useAppContext();

  useEffect(() => {
    const fetchData = async () => {
      await getContractProductQuantities(contractId);
    };
    fetchData();
  }, [getContractProductQuantities, contractId]);

  useEffect(() => {
    if (data != null) {
      const totalQuantity = data.filter((quantity) => quantity.productType !== 'REMAINING');
      const remainingQuantity = data.filter((quantity) => quantity.productType === 'REMAINING');
      setProductQuantity(totalQuantity);
      setProductQuantityRemaining(remainingQuantity[0]);
    }
  }, [data]);

  return (
    <>
      <CardRow>
        <CardRowCard>
          <BoughtChartCmp
            year={contractData.contractPeriod}
            isFix={contractData.isFix}
            data={productQuantity}
            error={error}
          />
        </CardRowCard>
        <CardRowCard>
          <PriceDevelopment type={contractData.commodity.id} userId={user?.id} contractId={contractId} />
        </CardRowCard>
      </CardRow>
      <TariffPrices />
      <RemainingQuantity data={productQuantityRemaining} error={error} contractId={contractId} customerId={contractData.customer.id} />
      <TransactionsList />
    </>
  );
};

ContractDetail.propTypes = {
  contractData: PropTypes.object,
};

export default ContractDetail;
